import React from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  entityName?: string;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmModal = ({ isOpen, entityName = 'this item', onDismiss, onConfirm }: DeleteConfirmModalProps) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="small">
      <ModalHeader title={`Delete ${entityName}?`} />
      <ModalBody>
        <Text size="medium" color="surface.text.gray.muted">
          Are you sure you want to delete {entityName}?
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="secondary" onClick={onDismiss}>
            Cancel
          </Button>
          <Button variant="primary" color="negative" onClick={onConfirm}>
            Delete
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
